import { useState } from "react";
import  ScenePic from "./images/anders-jilden-unsplash.jpg";
function FillDiv(){
  const [isHovering, setIsHovering] = useState(false);
  const [scenePicImage, setScenePicImage] = useState(ScenePic);
  const totalHeight = window.innerHeight
  const divFull = (num, padding , currentDelay) =>{
    let width = padding;
    let height = document.getElementById('filldiv').offsetHeight;
    if (width >= 300){
      return
    }
       

     console.log('width ',width)
     width = width +50;
     height = height +50;

     document.getElementById('filldiv').setAttribute("style","paddingLeft:"+width.toString()+"px");
     currentDelay += 10;
     setTimeout(() => {divFull(num-1 , currentDelay)}, currentDelay);
   }
   const handleMouseEnter = () => {
     setIsHovering(true);
     setTimeout(() => {divFull(10 , 10)},50, 10);
 
     console.log('Mouse entered');
   };
 
   const handleMouseLeave = () => {
     setIsHovering(false);
      // Function to call on mouse leave
      document.getElementById('filldiv').setAttribute("style","width:400px");
     console.log('Mouse left');
   };

    return(<>
    <div    style={{
            position: 'relative',
            width:'100%',
            height: totalHeight/2*1.3,
            backgroundImage: `url(${ScenePic})`,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex:4
          }}
          className={'mobileDiv'}
          >

      <div id='filldiv'>
      <h1 className='audience-font mt-10 font-palanquin text-8xl max-sm:text-[72px] max-sm:leading-[82px] font-bold'>
          <span className='xl:whitespace-nowrap relative z-10 pr-10'>
            Reach your
          </span>
          <br />
          <span className='text-coral-red inline-block mt-3'>Audience</span> 
        </h1>
      </div>

    </div>
    </>)
}

export default FillDiv